import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Combine class names, dedupe Tailwind utilities. The shadcn idiom. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
